<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <Container>
      <h1
        v-blokkli-editable:title
        class="text-4xl lg:text-7xl pb-5 lg:pb-12 hyphens-none"
      >
        {{ entity?.title || title }}
      </h1>
    </Container>
    <div class="grid-container">
      <div class="grid-container-8 pb-4">
        <div class="text-xl md:text-3xl" v-html="lead" />
        <div class="flex items-center gap-2 mt-8 pt-4 border-t">
          <SpriteSymbol name="newspaper" class="size-5" />
          {{
            props.location?.address?.locality
              ? props.location.address.locality + ', '
              : ''
          }}
          {{ props.date?.formatted }}
        </div>
      </div>

      <div class="grid-container-6">
        <MediaImage
          v-if="image"
          v-blokkli-droppable:field_image="{
            entityType: 'media',
            entityBundles: ['image'],
            cardinality: 1,
          }"
          v-bind="entity?.image || image"
          :image-style="imageStyle"
          class="mb-10"
        />
      </div>
    </div>
    <div>
      <BlokkliField :list="paragraphs" name="field_paragraphs" />
    </div>
    <NodeContactTeaserPressRelease :contact="contact" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePressReleaseFragment } from '#graphql-operations'

const props = defineProps<{
  uuid?: string
  title?: string
  lead?: string
  location?: NodePressReleaseFragment['location']
  image?: NodePressReleaseFragment['image']
  paragraphs?: NodePressReleaseFragment['paragraphs']
  date?: NodePressReleaseFragment['date']
  contact?: NodePressReleaseFragment['contact']
  canEdit?: NodePressReleaseFragment['canEdit']
  blokkliProps: NodePressReleaseFragment['blokkliProps']
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 4 / 3,
  sizes: {
    sm: 530,
    md: 728,
    lg: 796,
    xl: 1040,
  },
})
</script>
